import PropTypes from 'prop-types';
import React from 'react';

function Accordion({ onOpenedChange, openPosition, children, drawerProps }) {
  const nodes = children.map((node, index) => {
    return React.cloneElement(
      node,
      {
        ...drawerProps,
        onExpandChange: newExpandedState => {
          onOpenedChange(newExpandedState ? index : null);
        },
        expanded: openPosition === index,
      },
      node.props.children,
    );
  });

  return <div style={{ width: '100%' }}>{nodes}</div>;
}

Accordion.defaultProps = {
  openPosition: 0,
  drawerProps: {},
};

Accordion.propTypes = {
  openPosition: PropTypes.number,
  onOpenedChange: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  drawerProps: PropTypes.object,
};

export default Accordion;
